<template>
  <div class="container">
    <div class="block">
      <div class="mwow-detail-header">
        <div class="left">
          <div class="back-btn" @click="handleBack">
            <i class="el-icon-arrow-left"></i>
            <span>返回</span>
          </div>
        </div>
        <div class="mid">
          <p>套餐详情</p>
        </div>
        <div class="right"></div>
      </div>
      <el-form
        size="mini"
        class="main-form"
        :model="setDetailForm"
        label-width="88px"
        :rules="rules"
        ref="mainForm"
      >
        <el-form-item label="套餐名称:" prop="name">
          <el-input
            v-model="setDetailForm.name"
            placeholder="请输入"
            maxlength="120"
          ></el-input>
        </el-form-item>
        <el-form-item label="套餐备注:" prop="remark">
          <el-input
            v-model="setDetailForm.remark"
            type="textarea"
            placeholder="请输入备注"
          ></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="block">
      <p class="title">套餐内容</p>
      <div style="margin-bottom: 14px">
        <course-dialog
          :disable-list="setDetailForm.item"
          @change="updateCourseTable"
        >
          <div class="mwow-button-filled success">添加课程</div>
        </course-dialog>
      </div>
      <el-table
        size="mini"
        :data="setDetailForm.item"
        stripe
        v-horizontal-scroll
        class="set-table"
        ref="mainTable"
      >
        <el-table-column label="课程名称" prop="product_name"></el-table-column>
        <el-table-column label="课时定价" width="220">
          <template slot-scope="scope">
            <el-select
              v-model="scope.row.spec_id"
              @change="
                (v) => {
                  scope.row.spec_quantity = Number(allSpecObj[v].quantity);
                  scope.row.quantity = Number(allSpecObj[v].quantity);
                  scope.row.unit_price = Number(allSpecObj[v].unit_price);
                  scope.row.price = Number(allSpecObj[v].price);
                  handleRowChange(scope.row);
                }
              "
            >
              <el-option
                v-for="item in courseSpecObj[scope.row.product_id]"
                :key="item.course_spec_id"
                :label="item.pricing"
                :value="item.course_spec_id"
              ></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="购买数量" width="140">
          <template slot-scope="scope">
            <el-input
              style="width: 70px"
              v-model.number="scope.row.quantity"
              type="number"
              :disabled="scope.row.spec_quantity !== 1"
              @change="handleRowChange(scope.row)"
            ></el-input
            ><span style="margin-left: 6px">课时</span>
          </template>
        </el-table-column>
        <el-table-column label="总价" width="90" prop="price">
          <template slot-scope="scope">
            <span v-if="scope.row.spec_quantity !== 1">{{
              scope.row.price
            }}</span>
            <span v-else>{{
              solvePrice(scope.row.unit_price, scope.row.quantity)
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="直减" width="260"
          ><template slot-scope="scope">
            <el-select
              class="short"
              v-model="scope.row.discount_type"
              type="number"
              @change="handleRowChange(scope.row)"
            >
              <el-option label="直减" :value="1"></el-option>
              <!-- <el-option label="折扣" :value="2"></el-option> -->
            </el-select>
            <el-input
              style="width: 140px"
              v-model="scope.row.discount_amount"
              v-if="scope.row.discount_type === 1"
              type="number"
              @change="handleRowChange(scope.row)"
              @blur="handleBlur"
              @focus="handleFocus"
              @input="handleDiacountInput(scope.row)"
              ><template slot="append">￥</template></el-input
            >
            <!-- <el-input
              style="width: 140px"
              v-model.number="scope.row.discount"
              v-if="scope.row.discount_type === 2"
              type="number"
              ><template slot="append">%</template></el-input
            > -->
          </template></el-table-column
        >
        <el-table-column label="小计" width="160">
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.sum"
              type="number"
              @change="handleSumChange(scope.row)"
              @blur="handleBlur"
              @focus="handleFocus"
              @input="handleSumInput(scope.row)"
              ><template slot="append">￥</template></el-input
            >
          </template>
        </el-table-column>
        <el-table-column label="操作" width="80">
          <template slot-scope="scope">
            <div class="mwow-button info" @click="handleDeleteCourse(scope)">
              删除
            </div>
          </template>
        </el-table-column>
      </el-table>
      <p class="total-sum-wrap">
        套餐总价：<span class="red">￥{{ setDetailForm.price }}</span>
      </p>
      <div class="bottom-btns">
        <!-- <el-button class="mwow-button-filled">取消</el-button> -->
        <el-button class="mwow-button-filled success" @click="handleSubmit"
          >保存</el-button
        >
      </div>
    </div>
  </div>
</template>
<script>
import { setDetail, courseSpecList, createSet, editSet } from "@/api/course";
import { solveLargeNumber } from "@/utils/common";
import courseDialog from "./courseDialog.vue";
export default {
  components: {
    courseDialog,
  },
  data() {
    return {
      setDetailForm: {
        combo_product_id: 0,
        name: "",
        remark: "",
        price: 0,
        item: [],
      },
      setDetailFormCache: "",
      courseSpecObj: {},
      allSpecObj: {},
      rules: {
        name: [{ required: true, message: "请输入套餐名称", trigger: "blur" }],
      },
      blurStatus: true,
    };
  },
  created() {
    const id = Number(this.$route.query.id);
    if (id !== 0) {
      // 编辑
      setDetail({ combo_product_id: id }).then((res) => {
        if (res.error_code === 0) {
          this.setDetailForm = {
            combo_product_id: res.data.combo_product_id,
            name: res.data.name,
            remark: res.data.remark,
            price: Number(res.data.price), // 总价
            item: [],
          };
          res.data.item.map((item) => {
            courseSpecList({ course_id: item.product_id }).then((result) => {
              if (result.error_code === 0) {
                // 接口返回的quantity可能是spec_quantity为1的规格被修改后的数据，需要从规格列表里面找到原本的spec_quantity
                let spec_quantity = 0;
                result.data.list.map((j) => {
                  if (j.course_spec_id === item.spec_id) {
                    spec_quantity = Number(j.quantity);
                  }
                  this.allSpecObj[j.course_spec_id] = j;
                });
                this.courseSpecObj[item.product_id] = result.data.list;
                const format = {
                  product_name: item.product_name,
                  type: item.item_type,
                  product_id: item.product_id,
                  spec_id: item.spec_id,
                  spec_quantity: Number(spec_quantity),
                  quantity: Number(item.quantity),
                  unit_price: Number(item.unit_price), // 规格单价，spec_quantity为1时配合quantity使用
                  price: Number(item.spec_price), // 规格总价，spec_quantity大于1时使用
                  discount_type: item.discount === 0 ? 1 : 2,
                  discount: item.discount,
                  discount_amount: Number(item.discount_amount),
                  item_id: item.item_id,
                  sum: Number(item.subtotal),
                };
                this.setDetailForm.item.push(format);
                this.setDetailFormCache =
                  this.setDetailFormCache + JSON.stringify(format);
                this.solveTableTotal();
              }
            });
          });
        }
      });
    }
  },
  methods: {
    handleDeleteCourse(scope) {
      const copy = [...this.setDetailForm.item];
      copy.splice(scope.$index, 1);
      this.setDetailForm.item = copy;
      this.$nextTick(() => {
        this.solveTableTotal();
      });
    },
    solveSum(quantity, unit_price, discount_amount) {
      return (
        Math.ceil(
          (solveLargeNumber(quantity) * solveLargeNumber(unit_price) -
            solveLargeNumber(discount_amount) * 100) /
            100
        ) / 100
      );
    },
    solvePrice(quantity, unit_price) {
      return (
        Math.ceil(
          (solveLargeNumber(quantity) * solveLargeNumber(unit_price)) / 100
        ) / 100
      );
    },
    updateCourseTable(newArr) {
      const result = [...this.setDetailForm.item];
      Promise.all(
        newArr.map((cid) => {
          return new Promise((resolve) => {
            let specList;
            if (this.courseSpecObj[cid]) {
              specList = this.courseSpecObj[cid];
              resolve({
                product_name: specList[0].course_name,
                type: 1,
                product_id: specList[0].course_id,
                spec_id: specList[0].course_spec_id,
                spec_quantity: Number(specList[0].quantity),
                quantity: Number(specList[0].quantity),
                unit_price: Number(specList[0].unit_price),
                price: Number(specList[0].price),
                discount_type: 1,
                discount: 0,
                discount_amount: 0,
                sum: Number(specList[0].price),
              });
            } else {
              courseSpecList({ course_id: cid }).then((res) => {
                res.data.list.map((j) => {
                  this.allSpecObj[j.course_spec_id] = j;
                });
                this.courseSpecObj[cid] = res.data.list;
                specList = res.data.list;
                resolve({
                  product_name: specList[0].course_name,
                  type: 1,
                  product_id: specList[0].course_id,
                  spec_id: specList[0].course_spec_id,
                  spec_quantity: Number(specList[0].quantity),
                  quantity: Number(specList[0].quantity),
                  unit_price: Number(specList[0].unit_price),
                  price: Number(specList[0].price),
                  discount_type: 1,
                  discount: 0,
                  discount_amount: 0,
                  sum: Number(specList[0].price),
                });
              });
            }
          });
        })
      ).then((res) => {
        const arr = [...result, ...res];
        this.setDetailForm.item = arr;
        this.$nextTick(() => {
          this.solveTableTotal();
        });
      });
    },
    handleRowChange(row) {
      if (row.discount_type === 1) {
        row.quantity = Number(row.quantity.toFixed(2));
        row.discount_amount = Number(Number(row.discount_amount).toFixed(2));
        if (Number(row.spec_quantity) === 1) {
          row.sum = Number(
            this.solveSum(row.quantity, row.unit_price, row.discount_amount)
          );
        } else {
          row.sum =
            (solveLargeNumber(row.price) -
              solveLargeNumber(row.discount_amount)) /
            100;
        }
        this.solveTableTotal();
      }
    },
    handleSumChange(row) {
      row.sum = Number(Number(row.sum).toFixed(2));
      if (row.discount_type === 1) {
        if (Number(row.spec_quantity) === 1) {
          row.discount_amount = this.solveSum(
            row.quantity,
            row.unit_price,
            row.sum
          );
        } else {
          row.discount_amount =
            (solveLargeNumber(row.price) - solveLargeNumber(row.sum)) / 100;
        }
      }
      this.solveTableTotal();
    },
    solveTableTotal() {
      const table = this.$refs.mainTable;
      if (table.data) {
        let res = 0;
        table.data.map((row) => {
          res = res + Number(row.sum);
        });
        this.setDetailForm.price = Number(res.toFixed(2));
      }
    },
    handleSubmit() {
      this.$refs["mainForm"].validate((valid) => {
        if (valid) {
          // 判断表格完整性
          const table = this.$refs.mainTable;
          const tableData = table.data;
          if (tableData && tableData.length > 0) {
            let pass = true;
            let msg = "";
            tableData.map((item) => {
              if (typeof item.type !== "number" || item.type < 0) {
                pass = false;
                msg = "请选择套餐目录类型";
              }
              if (typeof item.product_id !== "number" || item.product_id < 0) {
                pass = false;
                msg = "请输入商品ID";
              }
              if (typeof item.spec_id !== "number" || item.spec_id < 0) {
                pass = false;
                msg = "请选择规格";
              }
              if (typeof item.quantity !== "number" || item.quantity < 1) {
                pass = false;
                msg = "购买数量不能为空或小于1";
              }
              if (
                typeof item.discount_type !== "number" ||
                item.discount_type < 0
              ) {
                pass = false;
                msg = "请选择优惠类型";
              }
              if (item.discount_type === 1) {
                if (
                  typeof item.discount_amount !== "number" ||
                  item.discount_amount < 0
                ) {
                  pass = false;
                  msg = "请正确填写直减数值";
                }
              }
              if (item.discount_type === 2) {
                if (typeof item.discount !== "number" || item.discount < 0) {
                  pass = false;
                  msg = "请正确填写折扣百分比";
                }
              }
              if (typeof item.sum !== "number" || item.sum < 0) {
                pass = false;
                msg = "请正确填写小计";
              }
            });
            if (!pass) {
              this.$message({
                type: "error",
                message: msg,
              });
              return false;
            }
          }
          const items = [];
          tableData.map((item) => {
            const params = {
              type: item.type,
              product_id: item.product_id,
              spec_id: item.spec_id,
              quantity: String(item.quantity),
              discount_type: item.discount_type === 1 ? 0 : 1,
              discount: String(
                item.discount_type === 1 ? item.discount_amount : item.discount
              ),
            };
            if (item.item_id) {
              params.item_id = item.item_id;
            }
            items.push(params);
          });
          // 发起请求
          const id = Number(this.$route.query.id);
          if (id !== 0) {
            // 编辑
            editSet({
              combo_product_id: id,
              name: this.setDetailForm.name,
              remark: this.setDetailForm.remark,
              item: items,
            }).then((res) => {
              if (res.error_code == 0) {
                this.$message({
                  type: "success",
                  message: "编辑成功!",
                });
                this.setDetailFormCache = this.setDetailForm.item
                  .map((item) => {
                    return JSON.stringify(item);
                  })
                  .join("");
                this.$router.push({
                  name: "storeCourse",
                });
              } else {
                this.$message({
                  type: "error",
                  message: "编辑失败!" + res.message,
                });
              }
            });
          } else {
            // 新增
            createSet({
              name: this.setDetailForm.name,
              remark: this.setDetailForm.remark,
              item: items,
            }).then((res) => {
              if (res.error_code == 0) {
                this.$message({
                  type: "success",
                  message: "新增成功!",
                });
                this.$router.push({
                  name: "storeCourse",
                });
              } else {
                this.$message({
                  type: "error",
                  message: "新增失败!" + res.message,
                });
              }
            });
          }
        }
      });
    },
    handleBack() {
      const o = this.setDetailFormCache;
      const n = this.setDetailForm.item
        .map((item) => {
          return JSON.stringify(item);
        })
        .join("");
      if (o !== n) {
        this.$confirm(
          "当前页面有编辑内容未保存，返回后数据将丢失，且无法找回。",
          `返回 - 套餐列表`,
          {
            confirmButtonText: "确定",
            confirmButtonClass: "mwow-button-filled success mini",
            cancelButtonText: "取消",
            cancelButtonClass: "mwow-button-filled mini",
            type: "warning",
          }
        )
          .then(() => {
            this.$router.go(-1);
          })
          .catch(() => {});
      } else {
        this.$router.go(-1);
      }
    },
    handleSumInput(row) {
      row.sum = Number(this.handleInput(row.sum));
    },
    handleDiacountInput(row) {
      row.discount_amount = this.handleInput(row.discount_amount);
    },
    // 输入逻辑控制
    handleInput(val) {
      let n = String(val);
      if (n.includes("-")) {
        this.$message({
          message: "不能为负数",
          type: "error",
        });
        let i = n.indexOf("-");
        n = n.slice(i + 1);
      }
      let l = n.split(".");
      // 如果有小数，并且小数的位数大于2，将2位之后的数直接截掉
      if (l.length > 1 && l[1].length > 2) {
        l[1] = l[1].slice(0, 2);
        this.$message({
          message: "最多输入两位小数",
          type: "error",
        });
      }
      return l.join(".");
    },
    // 获焦暂停计算
    handleFocus() {
      this.blurStatus = false;
    },
    // 失焦计算
    handleBlur() {
      this.blurStatus = true;
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
}
.mwow-detail-header {
  margin-bottom: 22px;
}
.block {
  border-radius: 4px;
  padding: 0 12px 12px 12px;
  background-color: #ffffff;
  margin: 12px 0;
  .el-textarea {
    width: 50%;
  }
  .el-table {
    .short {
      width: 80px !important;
    }
  }
  .title {
    font-size: 14px;
    color: #5c5d5e;
    font-weight: bold;
    line-height: 14px;
    margin-bottom: 25px;
    padding-top: 19px;
    .tips {
      font-size: 12px;
      color: #07d1aa;
      margin-left: 24px;
      font-weight: initial;
    }
  }
}
.total-sum-wrap {
  font-size: 18px;
  margin: 29px 0 120px 0;
  text-align: right;
  .red {
    color: #f56c6c;
  }
}
.bottom-btns {
  text-align: left;
}
</style>
